<template>
    <div class="dropdown-list">
        <custom-search
            @input="$emit('search', $event)"
            v-if="isSearchable"
        >
        </custom-search>

        <div class="list-wrapper">
            <loading
                class="empty"
                v-if="isLoading"
            >
            </loading>

            <ul v-else-if="items.length > 0">
                <li
                    v-for="(item,index) in items"
                    :key="index"
                    class="item"
                    @click="$emit('select', item)"
                >
                    <slot :item="item">
                        {{ item }}
                    </slot>
                </li>
            </ul>

            <p
                class="item empty"
                v-else
            >
                No result found.
            </p>
        </div>
    </div>
</template>

<script>
import CustomSearch from '@/components/utils/CustomSearch.vue'
import Loading from '@/components/utils/Loading.vue'

export default {
	props: {
		items: {
			type: Array,
			default: () => []
		},

		isLoading: {
			type: Boolean,
			default: false
		},

		isSearchable: {
			type: Boolean,
			default: true
		}
	},

	components: {
		CustomSearch,
		Loading
	}
}
</script>

<style lang="scss" scoped>
.dropdown-list {
    box-shadow: 0 3px 6px $shadow;
    padding: 10px;
    background-color: #fff;
    border: 1px solid $light;
    z-index: 999;

    .list-wrapper {
        max-height: 300px;
        overflow: auto;
        margin-top: 10px;

        .item {
            cursor: pointer;

            &:hover {
                background-color: $light2;
            }
        }
    }

    .item {
        padding: 5px 0;
    }

    .empty {
        text-align: center;
        margin: 0 auto;
    }
}
</style>
